/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section
const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Pedro Leitao",
  title: "Hi all, I'm Pedro",
  subTitle: emoji(
    "Senior Software Engineer with 12+ years of experience designing and building scalable backend systems, cloud solutions, and data-driven applications.\n\nSpecialized in .NET (C#), SQL, and cloud platforms (AWS & Azure), with strong experience in high-performance environments and enterprise-grade architectures.\n\nIn addition to backend engineering, I also have hands-on DevOps experience, working with CI/CD pipelines, infrastructure automation, cloud deployments, monitoring, and system reliability practices to support scalable and efficient software delivery.\n\nRecently, I've been focusing on AI and machine learning, exploring LLM-based applications, RAG architectures, and intelligent automation systems.\n\nI'm passionate about combining backend engineering, cloud, DevOps, and AI to build scalable and impactful systems.\n\nCurrently open to international and remote opportunities.\n\nLet's connect."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1xKyv-ZkJes6wdFXVqJpp7g49LbznifPt/view?usp=sharing",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/oleitao",
  linkedin: "https://www.linkedin.com/in/pedro-m-039b11279/",
  gmail: "pedromoleitao@gmail.com",
  // gitlab: "https://gitlab.com/",
  facebook: "https://www.facebook.com/pml87",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER/DEVOPS WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Cloud Infrastructure manage and monitoring resources always looking for optimization"),
    emoji("⚡ DevOps pipelines deployment from scratch"),
  ],


  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "microsoft",
      fontAwesomeClassname: "fab fa-microsoft"
    },
    {
      skillName: "linux",
      fontAwesomeClassname: "fab fa-linux"
    },

    {
      skillName: "git",
      fontAwesomeClassname: "fab fa-git"
    },

    {
      skillName: "github",
      fontAwesomeClassname: "fab fa-github"
    },

    {
      skillName: "octopus-deploy",
      fontAwesomeClassname: "fab fa-octopus-deploy"
    },

    {
      skillName: "jira",
      fontAwesomeClassname: "fab fa-jira"
    },

    {
      skillName: "code",
      fontAwesomeClassname: "fab fa-code"
    },

    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Instituto Superior de Engenharia do Porto",
      logo: require("./assets/images/isep.png"),
      subHeader: "Master of Science in Computer Science",
      duration: "September 2010 - November 2012",
    }
    // {
    //   schoolName: "Stanford University",
    //   logo: require("./assets/images/stanfordLogo.png"),
    //   subHeader: "Bachelor of Science in Computer Science",
    //   duration: "September 2013 - April 2017",
    //   desc: "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
    //   descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    // }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "10%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "75%"
    },
    {
      Stack: "DevOps",
      progressPercentage: "60%"
    },
    {
      Stack: "Clould",
      progressPercentage: "40%"
    },
    {
      Stack: "AI/LLM/MLOps",
      progressPercentage: "20%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Senior Software Engineer / DevOps",
      company: "Constellation Automotive Group Tech Hub",
      companylogo: require("./assets/images/natixis.jpg"),
      date: "November 2024 – Present",
      descBullets: [
        "Contributed to the development and maintenance of enterprise applications and digital platforms within the automotive technology sector",
        "Designed, developed, and maintained scalable backend solutions using .NET Core and cloud-based architectures (AWS)",
        "Worked closely with DevOps practices, creating and maintaining CI/CD pipelines, deployment workflows, and infrastructure automation processes",
        "Supported cloud environments and deployment operations, improving system reliability, scalability, and delivery efficiency",
        "Participated in the full software development lifecycle, including analysis, design, implementation, testing, deployment, and maintenance",
        "Collaborated with distributed and cross-functional international teams in fully remote Agile environments",
        "Improved application performance, system stability, and operational efficiency through troubleshooting, optimization, and continuous improvement initiatives",
        "Contributed to secure software delivery practices, including vulnerability mitigation, patching, and operational monitoring",
        "Supported highly available production systems and coordinated software releases, feature deployments (UAT / STG / PROD), and hotfix processes",
        "Developed and maintained technical documentation, operational procedures, and deployment guidelines for development and support teams",
        "Participated in architectural discussions and contributed to backend, cloud, and DevOps best practices across projects"
      ]
    },
    {
      role: "SENIOR .NET DEVELOPER",
      company: "Natixis Corporate & Investment Banking",
      companylogo: require("./assets/images/natixis.jpg"),
      date: "July 2022 – October 2024",
      descBullets: [
        "Contributed to the development and maintenance of enterprise applications for financial risk management within a global investment banking environment",
        "Designed, developed, and maintained scalable backend solutions using .NET technologies in high-availability systems",
        "Created and maintained DevOps pipelines to support CI/CD processes, automated deployments, and software delivery workflows",
        "Participated in the full software development lifecycle, including analysis, design, implementation, testing, deployment, and maintenance",
        "Collaborated with cross-functional teams, stakeholders, and end users in complex enterprise and financial projects",
        "Improved application performance, stability, and reliability through troubleshooting, optimization, and software enhancements",
        "Investigated and mitigated vulnerabilities, contributing to secure and compliant enterprise systems",
        "Supported scalable and highly available production environments, including deployment coordination and release management",
        "Produced technical documentation, operational procedures, and troubleshooting knowledge base materials",
        "Worked in Agile/Scrum environments, contributing to sprint planning, estimations, and delivery tracking",
        "Participated in continuous improvement initiatives, proposing technical enhancements and process optimizations",
        "Collaborated with DevOps and infrastructure teams to improve automation, deployment efficiency, and operational readiness"
      ]
    },
    {
      role: "SENIOR .NET APPLICATIONS DEVELOPER",
      company: "Efacec",
      companylogo: require("./assets/images/efacec.png"),
      date: "Mars 2020 – June 2022",
      descBullets: [
        "Contributed to the development and maintenance of Automation Studio 3, an industrial automation platform for electricity and energy management systems",
        "Developed and supported scalable .NET applications for automation and operational control environments",
        "Worked closely with DevOps practices, including deployment coordination, software delivery processes, vulnerability patching, and system reliability improvements",
        "Investigated and mitigated software and infrastructure vulnerabilities to improve security and operational stability",
        "Participated in the full software development lifecycle, including analysis, design, implementation, testing, deployment, and maintenance",
        "Collaborated with customers, managers, and technical teams in complex enterprise and industrial automation projects",
        "Tested and deployed scalable and highly available software solutions in production environments",
        "Performed troubleshooting, performance optimization, and software enhancements to improve system efficiency and reliability",
        "Supported hardware/software integration and resolved compatibility and interface-related issues",
        "Produced technical documentation, troubleshooting guides, and knowledge base materials for support and future maintenance",
        "Worked in Agile/Scrum environments, contributing to sprint estimations, planning, and delivery tracking",
        "Coordinated software releases, feature deployments, and production fixes across multiple environments"
      ]
    },
    {
      role: "ORACLE DEVELOPER",
      company: "Shared Services of Ministry of Health",
      companylogo: require("./assets/images/spms.png"),
      date: "February 2018 – February 2020",
      descBullets: [
        "Developed and maintained Oracle PL/SQL scripts and database solutions for the National User Registration platform within the Portuguese healthcare system",
        "Customized and optimized Oracle workflows to support business processes and operational requirements",
        "Provided technical expertise and support for enterprise Oracle applications used in large-scale public sector environments",
        "Collaborated with cross-functional development teams to identify, troubleshoot, and resolve application defects",
        "Improved system performance through database tuning, query optimization, and software enhancements",
        "Designed and maintained database structures, procedures, and data-processing functionalities for enterprise applications",
        "Participated in system maintenance, upgrades, and continuous improvement initiatives",
        "Worked in Agile/Scrum environments, contributing to estimations, sprint planning, and delivery tracking"
      ]
    },
    {
      role: "MIDDLE .NET DEVELOPER / SYSTEM ADMINISTRATOR",
      company: "AMOB",
      companylogo: require("./assets/images/amob-logo.png"),
      date: "January 2017 – February 2018",
      descBullets: [
        "Developed and maintained software solutions for CNC and industrial automation systems in manufacturing environments",
        "Worked on .NET-based applications and industrial software integrations for production and operational processes",
        "Provided technical support and helpdesk assistance for internal systems and infrastructure",
        "Administered IT infrastructure, including hardware provisioning, system maintenance, and network support",
        "Managed and supported wireless communication systems and enterprise connectivity solutions",
        "Implemented cost-effective technical solutions to improve operational efficiency and system usability",
        "Collaborated with end users to identify usability improvements and optimize software workflows",
        "Monitored infrastructure health, system reliability, and operational readiness across multiple environments",
        "Performed software testing and validation for server and production systems",
        "Developed internal tools and compatibility solutions to support software interoperability across platforms",
        "Implemented and maintained internet and intranet applications for internal business operations"
      ]
    },
    {
      role: "MIDDLE .NET DEVELOPER",
      company: "University of Minho",
      companylogo: require("./assets/images/um.png"),
      date: "April 2016 – February 2017",
      descBullets: [
        "Contributed to the development and maintenance of the Human Resources ERP system for the University of Minho",
        "Developed web and database-driven applications using .NET technologies and SQL-based systems",
        "Participated in the full software development lifecycle, including analysis, design, implementation, testing, and maintenance",
        "Designed and implemented database structures and backend functionalities for enterprise applications",
        "Built data-processing and integration capabilities to support interoperability between internal systems",
        "Developed internal integration platforms to improve communication between enterprise applications",
        "Produced technical documentation and development guidelines to support future maintenance and project scalability",
        "Collaborated in Agile development environments, contributing to system reliability and continuous improvement initiatives"
      ]
    },
    {
      role: ".NET DEVELOPER",
      company: "Engineering of the University of Porto",
      companylogo: require("./assets/images/feup.png"),
      date: "November 2012 – Mars 2016",
      descBullets: [
        "Contributed to the development of industrial automation software for supermarket product repositioning and production planning systems",
        "Developed and maintained applications using C++/CLI and database-driven architectures",
        "Participated in the full software development lifecycle, including analysis, design, implementation, testing, and maintenance",
        "Designed and developed web and database applications to support industrial and production processes",
        "Collaborated with cross-functional teams to translate business and operational requirements into technical solutions",
        "Built rapid prototypes and data-processing solutions to validate integration feasibility with existing systems",
        "Worked in Agile/Scrum environments, contributing to sprint planning, task estimation, and progress tracking",
        "Supported process optimization and automation initiatives in industrial production environments"
      ]
    },
    {
      role: ".NET DEVELOPER",
      company: "Engineering of the University of Porto",
      companylogo: require("./assets/images/feup.png"),
      date: "November 2012 – Mars 2016",
      descBullets: [
        "Contributed to the development and maintenance of internal web applications for supermarket product and shelf management systems",
        "Developed backend and database-driven solutions using C#, ASP.NET, and T-SQL",
        "Participated in the full software development lifecycle, including requirements analysis, design, implementation, testing, and maintenance",
        "Designed and implemented business logic for new systems, operational procedures, and testing workflows",
        "Collaborated with business and technical teams to translate operational requirements into scalable software solutions",
        "Developed rapid prototypes and data-processing functionalities to validate integration with existing enterprise systems",
        "Worked in Agile/Scrum environments, contributing to sprint planning, estimations, and delivery tracking",
        "Supported optimization and automation processes for retail management operations"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

// const openSource = {
//   showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
//   display: true // Set false to hide this section, defaults to true
// };

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/amob.png"),
      projectName: "AMOB",
      projectDesc: "AMOB CNC",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://amobgroup.com/software"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/jmalves.png"),
      projectName: "JMALVES",
      projectDesc: "Internal platform to manage clients documents and send notifications",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.jmalves.pt/"
        }
      ]
    },
    {
      image: "https://snapcraft.io/en/dark/install.svg",
      projectName: "JSON Studio",
      projectDesc: "Packages",
      footerLink: [
        {
          name: "Install from Snap Store",
          url: "https://snapcraft.io/jsonstudio-gtk"
        }
      ]
    }
  ],
  display: true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications and Some Cool Stuff that I have done !",

  achievementsCards: [

    {
      title: "Azure Architect",
      subtitle: "Microsoft",
      image: require("./assets/images/azure-architecture.png"),
      footerLink: [
        {name: "Certification", url: "https://www.credly.com/badges/0dd67cda-c03a-4717-aadc-07b85dffbb60/public_url"},
        {
          name: "Final Project",
          url: "https://github.com/oleitao/cre-2025"
        }
      ]
    },

    
    {
      title: "Designing and Implementing Microsoft Azure Networking Solutions",
      subtitle: "Microsoft AZ-700",
      image: require("./assets/images/microsoft_associate.png"),
      footerLink: [
        {name: "Certification", url: "https://drive.google.com/file/d/1uBuux4chWoYbWeOlkqn-3tWAvwUhlZ56/view?usp=sharing"},
      ]
    },

    {
      title: "Microsoft Azure Security Technologies",
      subtitle: "Microsoft AZ-500",
      image: require("./assets/images/microsoft_associate.png"),
      footerLink: [
        {name: "Certification", url: "https://drive.google.com/file/d/1E_Dp0vosBMnFau8NPS0iJDe182LpnnZo/view?usp=sharing"},
      ]
    },

    {
      title: "Designing Microsoft Azure Infrastructure Solutions",
      subtitle: "Microsoft AZ-305",
      image: require("./assets/images/azure_architect.png"),
      footerLink: [
        {name: "Certification", url: "https://drive.google.com/file/d/1iQBaiulHiSsozIEYcZIjGIkkpIGv05vp/view?usp=sharing"},
      ]
    },

    {
      title: "Develop Generative AI Solutions with Azure OpenAI Service",
      subtitle: "Microsoft AZ-700T00-A",
      image: require("./assets/images/azure_architect.png"),
      footerLink: [
      ]
    },

    {
      title: "Microsoft Certified: Azure AI Fundamentals",
      subtitle: "Microsoft AI-900T00-A",
      image: require("./assets/images/certified_fundamentals.png"),
      footerLink: [
      ]
    },

    {
      title: "Data Engineering with Python and AI/LLMs",
      subtitle: "dlt-hub",
      image: require("./assets/images/dltHub.png"),
      footerLink: [
        {name: "Certification", url: "https://github.com/dlt-hub/dlt-certificates/blob/main/certificates/technical_certification/2b96732e6c67728bdf55685acd5ea52a543c6a54fac38cb46f8456912ac69565.md"},
      ]
    },

    {
      title: "dlt Fundamentals",
      subtitle: "dlt-hub",
      image: require("./assets/images/dlt_ELT_specialist.png"),
      footerLink: [
        {name: "Certification", url: "https://github.com/dlt-hub/dlt-certificates/blob/main/certificates/technical_certification/e205d7fa33050950731ab6040b8eb658ddca9eaa8209e0cde07dcd0b32711cec.md"},
      ]
    },

    {
      title: "Astronomer Certification for Apache Airflow 3 Fundamentals",
      subtitle: "Astronomer",
      image: require("./assets/images/astronomer-certification-for-apache-airflow-3-funda.png"),
      footerLink: [
        {name: "Certification", url: "https://drive.google.com/file/d/1nUneomQLZPZRggQPcYRVvDYOzrcH6N94/view?usp=sharing"},
      ]
    },

    {
      title: "Astronomer Certification DAG Authoring for Apache Airflow 3",
      subtitle: "Astronomer",
      image: require("./assets/images/astronomer-certification-dag-authoring-for-apache-a.png"),
      footerLink: [
        {name: "Certification", url: "https://drive.google.com/file/d/1evBBVVowYCuCub62GajLZcafHNJMT_Pk/view?usp=sharing"},
      ]
    },

    {
      title: "MLOps Zoomcamp",
      subtitle: "DataTalks.Club",
      image: require("./assets/images/datatalks_club.jpeg"),
      footerLink: [
        {name: "Certification", url: "https://drive.google.com/file/d/1hOX0rocKQ2Rs8zyJgzve4glktsKZbN7-/view?usp=sharing"},
      ]
    },

    {
      title: "LLM Zoomcamp",
      subtitle: "DataTalks.Club",
      image: require("./assets/images/datatalks_club.jpeg"),
      footerLink: [
        {name: "Certification", url: "https://drive.google.com/file/d/1NBKJDqc1m1vUkvWRXZtozsaaFohWSYCN/view?usp=sharing"},
      ]
    },
    
    {
      title: "Fundamentos de Inteligência Artificial",
      subtitle: "RUMOS",
      image: require("./assets/images/artificial-intelligence-fundamentals.png"),
      footerLink: [
        {name: "Certification", url: "https://www.credly.com/badges/5b048585-e7e9-428a-8b5e-dbbae8930482/public_url"},
      ]
    },

    {
      title: "AWS Educate Getting Started with Networking",
      subtitle: "AWS",
      image: require("./assets/images/aws-educate-getting-started-with-networking-trainin.png"),
      footerLink: [
        {name: "Certification", url: "https://www.credly.com/badges/197cc1e0-0738-4675-89bc-1f9693efb7fe/public_url"},
      ]
    },

    {
      title: "Creativity with Copilot",
      subtitle: "GALILEU",
      image: require("./assets/images/creativity-with-copilot.png"),
      footerLink: [
        {name: "Certification", url: "https://www.credly.com/badges/c5d92bc5-d4e4-48c5-b621-5c45c9436359/public_url"},
      ]
    },
    
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "20º Portuguese Meeting of Computer Graphics",
      slides_url: "https://gpcg.pt/docs/20-ActasEPCG.pdf",
      event_url: "https://gpcg.pt/website/en/actas-de-conferencias/"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: true // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  // number: "+92-0000000000",
  email_address: "pedromoleitao@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  // openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
